"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderActions = exports.ShiftActions = exports.ShiftType = exports.ShiftStatus = void 0;
var ShiftStatus;
(function (ShiftStatus) {
    ShiftStatus["OPEN"] = "OPEN";
    ShiftStatus["CLOSED"] = "CLOSED";
})(ShiftStatus = exports.ShiftStatus || (exports.ShiftStatus = {}));
var ShiftType;
(function (ShiftType) {
    ShiftType["DEVICE"] = "DEVICE";
    ShiftType["EMPLOYEE"] = "EMPLOYEE";
    ShiftType["STORE"] = "STORE";
})(ShiftType = exports.ShiftType || (exports.ShiftType = {}));
var ShiftActions;
(function (ShiftActions) {
    ShiftActions["MONEY_MOVEMENT_ADDED"] = "MONEY_MOVEMENT_ADDED";
    ShiftActions["SHIFT_CLOSE"] = "SHIFT_CLOSE";
    ShiftActions["BALANCE_PAYMENT_RECEIVED"] = "BALANCE_PAYMENT_RECEIVED";
    ShiftActions["CUSTOMER_BALANCE"] = "CUSTOMER_BALANCE";
})(ShiftActions = exports.ShiftActions || (exports.ShiftActions = {}));
var OrderActions;
(function (OrderActions) {
    OrderActions["ORDER_COMPLETED_OR_REFUNDED"] = "ORDER_COMPLETED_OR_REFUNDED";
    OrderActions["ORDER_VOID"] = "ORDER_VOID";
    OrderActions["ORDER_SNAPSHOT_CREATED"] = "ORDER_SNAPSHOT_CREATED";
})(OrderActions = exports.OrderActions || (exports.OrderActions = {}));
//# sourceMappingURL=shift.js.map